import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "./pages/login";
import Signup from "./pages/signup";
import ForgotPassword from "./pages/forgot-password";
import ResetPassword from "./pages/reset-password";
import Dashboard from "./pages/dashboard";
import JobTracker from "./pages/job-tracker";
import JobAgent from "./pages/job-agent";
import Pricing from "./pages/pricing";
import FormControl from "./pages/form-control";
import Settings from "./pages/settings";
import ExternalApply from "./pages/external-apply";
import FilterSettings from "./pages/filter-settings";
import EmailPage from "./pages/email";
import FindHRPage from "./pages/find-hr";
import ProfilePage from "./pages/profile";
import AdminPanel from "./pages/admin";
import { useEffect } from "react";

const router = createBrowserRouter([
  { path: "/", element: <Login /> },
  { path: "/login", element: <Login /> },
  { path: "/signup", element: <Signup /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/settings", element: <Settings /> },
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/job-tracker", element: <JobTracker /> },
  { path: "/job-agent", element: <JobAgent /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "/form-control", element: <FormControl /> },
  { path: "/external-apply", element: <ExternalApply /> },
  { path: "/filter-settings", element: <FilterSettings /> },
  { path: "/email", element: <EmailPage /> },
  { path: "/find-hr", element: <FindHRPage /> },
  { path: "/profile", element: <ProfilePage /> },
  { path: "/oauth2callback", element: <EmailPage /> }, // Gmail OAuth callback
  { path: "/admin", element: <AdminPanel /> },
  { path: "*", element: <Login /> },
]);

function App() {
  useEffect(() => {
    // Ask the content-script (in this page) for the token via postMessage.
    // This avoids hardcoding an extension id and works across machines/environments.
    let done = false;
    const handleMessage = (event) => {
      if (event.source !== window) return;
      const data = event.data || {};
      if (data?.source !== "applyease" || data?.action !== "Token") return;
      done = true;
      if (data.token) localStorage.setItem("token", data.token);
    };
    window.addEventListener("message", handleMessage);
    try {
      window.postMessage({ source: "applyease-web", action: "RequestToken" }, "*");
    } catch {}
    const id = setTimeout(() => {
      if (!done) {
        // No-op: user can still login normally and localStorage will be populated.
      }
    }, 800);
    return () => {
      clearTimeout(id);
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
